import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var ReverseStrPipe = (function () {
    function ReverseStrPipe() {
    }
    ReverseStrPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return Array.from(input).reverse().join('');
    };
    return ReverseStrPipe;
}());
export { ReverseStrPipe };
ReverseStrPipe.decorators = [
    { type: Pipe, args: [{
                name: 'reverseStr'
            },] },
];
/** @nocollapse */
ReverseStrPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=reverse-str.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/reverse-str.pipe.js
// module id = 286
// module chunks = 103